/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string };
  JSON: { input: any; output: any };
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any };
  UUID: { input: string; output: string };
};

export type Address = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressNullable = {
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Defines when a policy shall be executed. */
export type ApplyPolicy =
  /** After the resolver was executed. */
  | 'AFTER_RESOLVER'
  /** Before the resolver was executed. */
  | 'BEFORE_RESOLVER'
  /** The policy is applied in the validation step before the execution. */
  | 'VALIDATION';

export type Appointment = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['String']['output'];
  host: Employee;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AppointmentDailyEventsStatusCount = {
  date: Scalars['DateTime']['output'];
  statusesCount: Array<AppointmentEventsStatusCount>;
};

export type AppointmentEvent = {
  appointment: Appointment;
  appointmentId: Scalars['String']['output'];
  careHome: Maybe<CatalogCareHome>;
  careHomeId: Maybe<Scalars['String']['output']>;
  encounter: Maybe<Encounter>;
  group: EventGroupId;
  host: Employee;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period: PeriodOfDateTimeOffset;
  recurrence: Maybe<Recurrence>;
  reference: Maybe<AppointmentTypeTemplate>;
  referenceId: Maybe<Scalars['String']['output']>;
  status: AppointmentEventStatus;
  tenantId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AppointmentEventStatus =
  | 'Attended'
  | 'Cancelled'
  | 'InProgress'
  | 'LateCancelled'
  | 'NoShow'
  | 'Scheduled';

export type AppointmentEventsStatusCount = {
  count: Scalars['Int']['output'];
  status: AppointmentEventStatus;
};

export type AppointmentRequest = {
  createdAt: Scalars['DateTime']['output'];
  declinedNote: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  note: Maybe<Scalars['String']['output']>;
  requestedPeriod: Maybe<PeriodOfDateTimeOffset>;
  status: AppointmentRequestStatus;
  tenantId: Scalars['String']['output'];
  visitorRefs: Array<VisitorRefGraphQl>;
};

export type AppointmentRequestStatus = 'Active' | 'Cancelled' | 'Completed' | 'Declined';

export type AppointmentTypeTemplate = {
  archived: Scalars['Boolean']['output'];
  consentTemplateIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  durationInMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  status: AppointmentTypeTemplateStatus;
};

export type AppointmentTypeTemplateStatus = 'ACTIVE' | 'INACTIVE';

export type Availability = {
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period: PeriodOfDateTimeOffset;
};

export type CatalogCareHome = {
  address: Maybe<Address>;
  archived: Scalars['Boolean']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  providerId: Maybe<Scalars['UUID']['output']>;
  type: CatalogCareHomeType;
};

export type CatalogCareHomeType = 'PHYSICAL' | 'TELEHEALTH';

export type Connection = {
  chatId: Scalars['UUID']['output'];
  employeeId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  organizationId: Scalars['UUID']['output'];
  patientId: Scalars['UUID']['output'];
};

export type Consent = {
  assignee: Maybe<Patient>;
  assigneeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['String']['output'];
  data: Scalars['String']['output'];
  eSignature: Maybe<ESignature>;
  encounter: Maybe<Encounter>;
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  signatureType: Maybe<ConsentSignatureType>;
  signedAt: Maybe<Scalars['DateTime']['output']>;
  signedBy: Maybe<User>;
  signerDetails: Maybe<ConsentSignerDetails>;
  status: ConsentStatus;
  tenantId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ConsentSignatureType = 'CHECKBOX' | 'SIGNATURE';

export type ConsentSignerDetails = {
  address: AddressNullable;
  name: Scalars['String']['output'];
  relation: Maybe<Scalars['String']['output']>;
  role: ConsentSignerRole;
};

export type ConsentSignerRole = 'CARER_OF_PATIENT' | 'NEXT_OF_KIN' | 'PATIENT';

export type ConsentStatus = 'NOT_SIGNED' | 'SIGNED';

export type ConsentTemplate = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['String']['output'];
  data: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAssigneeSignatureRequired: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  signatureType: Maybe<ConsentSignatureType>;
  tenantId: Scalars['String']['output'];
};

export type DayOfWeek = 'Friday' | 'Monday' | 'Saturday' | 'Sunday' | 'Thursday' | 'Tuesday' | 'Wednesday';

export type DocumentTag = {
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
};

export type ESignature = {
  meta: ESignatureMeta;
  note: Maybe<Scalars['String']['output']>;
  signature: Scalars['String']['output'];
  signedBy: User;
  signedById: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ESignatureMeta = {
  ipAddress: Maybe<Scalars['String']['output']>;
};

export type Employee = IUser & {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  appointmentHostPreferences: Maybe<HostPreferences>;
  avatar: Maybe<Scalars['String']['output']>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  connection: Maybe<Connection>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastAppointment: Maybe<LastAppointment>;
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  providerInfo: Maybe<ProviderInfo>;
  roles: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Encounter = {
  appointment: Maybe<EncounterAppointment>;
  completedOn: Maybe<Scalars['DateTime']['output']>;
  disabled: Scalars['Boolean']['output'];
  eSignatures: Array<ESignature>;
  examination: Maybe<Scalars['JSON']['output']>;
  glaucomaTestAttempts: Array<GlaucomaTestAttempt>;
  glaucomaTests: Maybe<GlaucomaTests>;
  history: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  note: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  patient: Patient;
  patientId: Scalars['UUID']['output'];
  /** Most recent prior visit for this patient; null if none. */
  previousEncounter: Maybe<Encounter>;
  provider: Employee;
  providerId: Scalars['UUID']['output'];
  status: EncounterStatus;
  summary: Maybe<Scalars['JSON']['output']>;
  version: Scalars['String']['output'];
};

export type EncounterAppointment = {
  careHome: CatalogCareHome;
  careHomeId: Scalars['UUID']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
  templateId: Maybe<Scalars['UUID']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type EncounterNote = {
  value: Scalars['JSON']['output'];
};

export type EncounterStatus = 'COMPLETED' | 'DISCARDED' | 'IN_PROGRESS';

export type EncounterTemplate = {
  directory: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  note: Scalars['JSON']['output'];
  organizationId: Scalars['UUID']['output'];
  providerId: Maybe<Scalars['UUID']['output']>;
  root: Scalars['String']['output'];
};

export type EventGroupId = {
  end: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  offset: Scalars['Int']['output'];
  start: Scalars['LocalDate']['output'];
};

export type FullNameNullable = {
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
};

export type GlaucomaTestAttempt = {
  id: Scalars['UUID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  resultReceivedAt: Maybe<Scalars['DateTime']['output']>;
  teleportId: Scalars['String']['output'];
};

export type GlaucomaTests = {
  portalUrl: Maybe<Scalars['String']['output']>;
};

export type HostPreferences = {
  defaultAppointmentDurationMinutes: Scalars['Int']['output'];
  hostId: Scalars['String']['output'];
};

export type HostSlotList = {
  hostId: Scalars['String']['output'];
  slots: Array<Slot>;
};

export type IUser = {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  avatar: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type LastAppointment = {
  hostId: Scalars['String']['output'];
  last: LastAppointmentValue;
  lastAttended: Maybe<LastAppointmentByTypeValue>;
  visitorId: Scalars['String']['output'];
};

export type LastAppointmentByTypeValue = {
  appointmentId: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
};

export type LastAppointmentValue = {
  appointmentId: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
  status: AppointmentEventStatus;
};

export type ListSegmentOfCatalogCareHome = {
  items: Array<CatalogCareHome>;
  total: Scalars['Int']['output'];
};

export type ListSegmentOfOrganization = {
  /** The items in the current segment. */
  items: Array<Organization>;
  /** The total number of items. -1 if unspecified. */
  total: Scalars['Int']['output'];
};

export type ListSegmentOfPatient = {
  /** The items in the current segment. */
  items: Array<Patient>;
  /** The total number of items. -1 if unspecified. */
  total: Scalars['Int']['output'];
};

export type ListSegmentOfSpecialty = {
  items: Array<Specialty>;
  total: Scalars['Int']['output'];
};

export type MgRecurrence = {
  pattern: MgRecurrencePattern;
  period: MgRecurrencePeriod;
};

export type MgRecurrencePattern = {
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  daysOfWeek: Maybe<Array<DayOfWeek>>;
  firstDayOfWeek: Maybe<DayOfWeek>;
  index: Maybe<MgRecurrenceRelativeIndex>;
  interval: Scalars['Int']['output'];
  month: Maybe<Scalars['Int']['output']>;
  type: RecurrenceType;
};

export type MgRecurrencePeriod = {
  end: Maybe<Scalars['LocalDate']['output']>;
  numberOfOccurrences: Maybe<Scalars['Int']['output']>;
  start: Scalars['LocalDate']['output'];
};

export type MgRecurrenceRelativeIndex = 'First' | 'Fourth' | 'Last' | 'Second' | 'Third';

export type NextOfKin = {
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  relationship: Maybe<NextOfKinRelationship>;
};

export type NextOfKinRelationship =
  | 'CARER'
  | 'CHILD'
  | 'FRIEND'
  | 'OTHER'
  | 'PARENT'
  | 'PARTNER'
  | 'SIBLING'
  | 'SPOUSE';

export type NotificationSetting = {
  email: Scalars['Boolean']['output'];
  internal: Scalars['Boolean']['output'];
  type: NotificationType;
};

export type NotificationType =
  | 'AppointmentCancelledByPatient'
  | 'AppointmentCancelledByProvider'
  | 'AppointmentCreatedByPatient'
  | 'AppointmentCreatedByProvider'
  | 'ChatMessageReceived'
  | 'ConsentFormAssignedCareHomeStaff'
  | 'ConsentFormAssignedPatient'
  | 'ConsentFormSignedCoordinator'
  | 'ConsentFormSignedPerformer'
  | 'DocumentSignRequired'
  | 'FileSharedWithPatient'
  | 'TreatmentPlanEditRequest'
  | 'VisitCancelledCareHomeStaff'
  | 'VisitCancelledCoordinator'
  | 'VisitCancelledPatient'
  | 'VisitCancelledPerformer'
  | 'VisitDueInFourteenDaysCareHomeStaff'
  | 'VisitDueInFourteenDaysPatient'
  | 'VisitDueInOneDayCareHomeStaff'
  | 'VisitDueInOneDayPatient'
  | 'VisitDueInTwoDaysCareHomeStaff'
  | 'VisitDueInTwoDaysPatient'
  | 'VisitRequestedCoordinator'
  | 'VisitScheduledCareHomeStaff'
  | 'VisitScheduledCoordinator'
  | 'VisitScheduledPatient'
  | 'VisitScheduledPerformer';

export type Organization = {
  billingContacts: OrganizationContactInfo;
  contacts: OrganizationContactInfo;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  twoFactorLoginRequired: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationContactInfo = {
  address: Address;
  contactPersonName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type Patient = {
  account: Maybe<UserAccount>;
  address: Address;
  avatar: Maybe<Scalars['String']['output']>;
  careHome: Maybe<CatalogCareHome>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  connection: Maybe<Connection>;
  contacts: PatientContactInfo;
  dateOfBirth: Scalars['DateTime']['output'];
  domiciliaryReason: Maybe<PatientDomiciliaryReason>;
  firstName: Scalars['String']['output'];
  fundingType: Maybe<PatientFundingType>;
  generalPractitioner: Maybe<PatientGeneralPractitioner>;
  gosNote: Maybe<Scalars['String']['output']>;
  hasAccount: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** True when the patient's recall date has passed and no scheduled upcoming appointment exists. */
  isOverdue: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** The most recent encounter for this patient; null if none. */
  latestEncounter: Maybe<Encounter>;
  nextOfKin: Array<NextOfKin>;
  nhsNumber: Maybe<Scalars['String']['output']>;
  niNumber: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  resourceId: Maybe<Scalars['String']['output']>;
  sex: Sex;
  status: PatientStatus;
  threadExists: Scalars['Boolean']['output'];
  title: Maybe<PatientTitle>;
};

export type PatientContactInfo = {
  additionalPhone: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type PatientDomiciliaryReason = 'CARE_HOME_RESIDENT' | 'HOUSEBOUND' | 'OTHER' | 'PHYSICAL_DISABILITY';

export type PatientFundingType = 'CORPORATE' | 'NHS' | 'PRIVATE';

export type PatientGeneralPractitioner = {
  gpName: Maybe<Scalars['String']['output']>;
  practiceAddress: Maybe<PatientGpPracticeAddress>;
  practiceEmail: Maybe<Scalars['String']['output']>;
  practiceName: Maybe<Scalars['String']['output']>;
  practicePhone: Maybe<Scalars['String']['output']>;
};

export type PatientGpPracticeAddress = {
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type PatientStatus = 'ACTIVE' | 'INACTIVE';

export type PatientTitle = 'DR' | 'MISS' | 'MR' | 'MRS' | 'MS' | 'PROF';

export type PeriodOfDateTimeOffset = {
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type PeriodOfDateTimeOffsetInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type ProviderInfo = {
  job: Scalars['String']['output'];
  providerRating: Maybe<ProviderRating>;
  specialty: Maybe<Specialty>;
  specialtyId: Maybe<Scalars['UUID']['output']>;
};

export type ProviderRating = {
  averageRating: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
};

export type ProviderSettings = {
  organizationId: Scalars['UUID']['output'];
  providerId: Scalars['UUID']['output'];
};

export type Query = {
  appointmentEvent: Maybe<AppointmentEvent>;
  appointmentEvents: Array<AppointmentEvent>;
  appointmentEventsCount: Scalars['Int']['output'];
  appointmentEventsDailyStatusesCount: Array<AppointmentDailyEventsStatusCount>;
  appointmentEventsStatusesCount: Array<AppointmentEventsStatusCount>;
  appointmentRequest: Maybe<AppointmentRequest>;
  appointmentRequests: Array<AppointmentRequest>;
  appointmentTypeTemplate: AppointmentTypeTemplate;
  appointmentTypeTemplates: Array<AppointmentTypeTemplate>;
  availabilities: Array<Availability>;
  careHomesListSegment: ListSegmentOfCatalogCareHome;
  catalogCareHome: Maybe<CatalogCareHome>;
  catalogCareHomeCount: Scalars['Int']['output'];
  catalogCareHomes: Array<CatalogCareHome>;
  consent: Maybe<Consent>;
  consentTemplate: Maybe<ConsentTemplate>;
  consentTemplates: Array<ConsentTemplate>;
  consents: Array<Consent>;
  consentsCount: Scalars['Int']['output'];
  currentUser: Maybe<User>;
  documentTag: Maybe<DocumentTag>;
  documentTagCount: Scalars['Int']['output'];
  documentTags: Array<DocumentTag>;
  employee: Maybe<Employee>;
  employees: Array<Employee>;
  employeesById: Array<Employee>;
  encounter: Maybe<Encounter>;
  encounterByAppointmentEventId: Maybe<Encounter>;
  encounterCount: Scalars['Int']['output'];
  encounterTemplate: Maybe<EncounterTemplate>;
  encounterTemplateRoots: Array<Scalars['String']['output']>;
  encounterTemplates: Array<EncounterTemplate>;
  encounters: Array<Encounter>;
  firstAppointmentEventByAppointmentId: Maybe<AppointmentEvent>;
  hostPreferencesByHostId: Maybe<HostPreferences>;
  organization: Organization;
  organizationsListSegment: ListSegmentOfOrganization;
  patient: Patient;
  patientsListSegment: ListSegmentOfPatient;
  providerSettings: Maybe<ProviderSettings>;
  providerSettingsCount: Scalars['Int']['output'];
  searchProvider: Array<Employee>;
  searchProvidersByPatient: Array<Employee>;
  slots: Array<Maybe<HostSlotList>>;
  specialties: Array<Specialty>;
  specialtiesListSegment: ListSegmentOfSpecialty;
  specialty: Maybe<Specialty>;
  specialtyCount: Scalars['Int']['output'];
  user: Maybe<User>;
  users: Array<User>;
};

export type QueryAppointmentEventArgs = {
  id: Scalars['String']['input'];
};

export type QueryAppointmentEventsArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsDailyStatusesCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsStatusesCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentRequestArgs = {
  id: Scalars['String']['input'];
};

export type QueryAppointmentRequestsArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryAppointmentTypeTemplateArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryAppointmentTypeTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryAvailabilitiesArgs = {
  from: Scalars['DateTime']['input'];
  hostIds: Array<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};

export type QueryCareHomesListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryCatalogCareHomeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryCatalogCareHomeCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryCatalogCareHomesArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentArgs = {
  id: Scalars['String']['input'];
};

export type QueryConsentTemplateArgs = {
  id: Scalars['String']['input'];
};

export type QueryConsentTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentsArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentsCountArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryDocumentTagArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDocumentTagCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryDocumentTagsArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryEmployeeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEmployeesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEmployeesByIdArgs = {
  ids: Array<Scalars['UUID']['input']>;
};

export type QueryEncounterArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEncounterByAppointmentEventIdArgs = {
  appointmentEventId: Scalars['String']['input'];
};

export type QueryEncounterCountArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncounterTemplateArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEncounterTemplateRootsArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncounterTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncountersArgs = {
  careHomeIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  hasClaim: InputMaybe<Scalars['Boolean']['input']>;
  ids: InputMaybe<Array<Scalars['UUID']['input']>>;
  patientIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
  providerIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  specialtyIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  statuses: InputMaybe<Array<EncounterStatus>>;
};

export type QueryFirstAppointmentEventByAppointmentIdArgs = {
  appointmentId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type QueryHostPreferencesByHostIdArgs = {
  hostId: Scalars['String']['input'];
};

export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOrganizationsListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryPatientArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryPatientsListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  searchValue: InputMaybe<Scalars['String']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryProviderSettingsArgs = {
  providerId: Scalars['UUID']['input'];
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryProviderSettingsCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySearchProviderArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  from: InputMaybe<Scalars['DateTime']['input']>;
  specialtyId: InputMaybe<Scalars['UUID']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySearchProvidersByPatientArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['UUID']['input'];
};

export type QuerySlotsArgs = {
  extra: InputMaybe<Scalars['JSON']['input']>;
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  period: PeriodOfDateTimeOffsetInput;
};

export type QuerySpecialtiesArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QuerySpecialtiesListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QuerySpecialtyArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySpecialtyCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryUsersArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type Recurrence = {
  mgRecurrence: Maybe<MgRecurrence>;
};

export type RecurrenceType =
  | 'AbsoluteMonthly'
  | 'AbsoluteYearly'
  | 'Daily'
  | 'RelativeMonthly'
  | 'RelativeYearly'
  | 'Weekly';

export type Sex = 'FEMALE' | 'MALE' | 'OTHER' | 'PREFER_NOT_TO_SAY';

export type Slot = {
  period: PeriodOfDateTimeOffset;
};

export type Specialty = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
};

export type User = IUser & {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  avatar: Maybe<Scalars['String']['output']>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type UserAccount = {
  creating: Scalars['Boolean']['output'];
  emailConfirmed: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  passwordLockedOut: Maybe<Scalars['Boolean']['output']>;
};

export type VisitorRefGraphQl = {
  appointmentType: Maybe<AppointmentTypeTemplate>;
  referenceId: Maybe<Scalars['String']['output']>;
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AddressFragment = {
  street: string;
  city: string;
  region: string | null;
  country: string;
  zipCode: string;
  line2: string | null;
};

type UserLookup_Employee_Fragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  active: boolean;
};

type UserLookup_User_Fragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  active: boolean;
};

export type UserLookupFragment = UserLookup_Employee_Fragment | UserLookup_User_Fragment;

export type ESignatureMetaFragment = { ipAddress: string | null };

export type ESignatureFragment = {
  timestamp: string;
  note: string | null;
  signature: string;
  signedById: string;
  meta: { ipAddress: string | null };
  signedBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
  };
};

export type PatientPortalAppointmentRequestFragment = {
  id: string;
  status: AppointmentRequestStatus;
  note: string | null;
  declinedNote: string | null;
  createdAt: string;
  requestedPeriod: { start: string; end: string } | null;
  visitorRefs: Array<{
    visitorId: string;
    referenceId: string | null;
    appointmentType: { id: string; name: string; durationInMinutes: number } | null;
  }>;
};

export type GetPatientPortalAppointmentRequestsQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetPatientPortalAppointmentRequestsQuery = {
  appointmentRequests: Array<{
    id: string;
    status: AppointmentRequestStatus;
    note: string | null;
    declinedNote: string | null;
    createdAt: string;
    requestedPeriod: { start: string; end: string } | null;
    visitorRefs: Array<{
      visitorId: string;
      referenceId: string | null;
      appointmentType: { id: string; name: string; durationInMinutes: number } | null;
    }>;
  }>;
};

export type GetPatientPortalAppointmentRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPatientPortalAppointmentRequestQuery = {
  appointmentRequest: {
    id: string;
    status: AppointmentRequestStatus;
    note: string | null;
    declinedNote: string | null;
    createdAt: string;
    requestedPeriod: { start: string; end: string } | null;
    visitorRefs: Array<{
      visitorId: string;
      referenceId: string | null;
      appointmentType: { id: string; name: string; durationInMinutes: number } | null;
    }>;
  } | null;
};

export type AppointmentTypeTemplateFragment = {
  id: string;
  name: string;
  durationInMinutes: number;
  archived: boolean;
  createdAt: string;
};

export type GetAppointmentTypeTemplatesQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAppointmentTypeTemplatesQuery = {
  appointmentTypeTemplates: Array<{
    id: string;
    name: string;
    durationInMinutes: number;
    archived: boolean;
    createdAt: string;
  }>;
};

export type GetAppointmentTypeTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetAppointmentTypeTemplateQuery = {
  appointmentTypeTemplate: {
    id: string;
    name: string;
    durationInMinutes: number;
    archived: boolean;
    createdAt: string;
  };
};

export type CatalogCareHomeFragment = {
  id: string;
  name: string;
  type: CatalogCareHomeType;
  archived: boolean;
  providerId: string | null;
  address: {
    street: string;
    city: string;
    region: string | null;
    zipCode: string;
    country: string;
    line2: string | null;
  } | null;
};

export type CatalogCareHomeLookupFragment = {
  id: string;
  type: CatalogCareHomeType;
  name: string;
  address: {
    street: string;
    city: string;
    region: string | null;
    zipCode: string;
    country: string;
    line2: string | null;
  } | null;
};

export type GetCatalogCareHomesListSegmentQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetCatalogCareHomesListSegmentQuery = {
  careHomesListSegment: {
    total: number;
    items: Array<{
      id: string;
      name: string;
      type: CatalogCareHomeType;
      archived: boolean;
      providerId: string | null;
      address: {
        street: string;
        city: string;
        region: string | null;
        zipCode: string;
        country: string;
        line2: string | null;
      } | null;
    }>;
  };
};

export type GetCatalogCareHomesQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCatalogCareHomesQuery = {
  catalogCareHomes: Array<{
    id: string;
    name: string;
    type: CatalogCareHomeType;
    archived: boolean;
    providerId: string | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      zipCode: string;
      country: string;
      line2: string | null;
    } | null;
  }>;
};

export type GetCatalogCareHomesLookupListQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCatalogCareHomesLookupListQuery = {
  catalogCareHomes: Array<{
    id: string;
    type: CatalogCareHomeType;
    name: string;
    address: {
      street: string;
      city: string;
      region: string | null;
      zipCode: string;
      country: string;
      line2: string | null;
    } | null;
  }>;
};

export type EncounterTemplateFragment = {
  id: string;
  root: string;
  directory: string | null;
  name: string;
  note: any;
};

export type GetEncounterTemplatesQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEncounterTemplatesQuery = {
  encounterTemplates: Array<{ id: string; root: string; directory: string | null; name: string; note: any }>;
};

export type GetEncounterTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEncounterTemplateQuery = {
  encounterTemplate: { id: string; root: string; directory: string | null; name: string; note: any } | null;
};

export type GetEncounterTemplateRootsQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEncounterTemplateRootsQuery = { encounterTemplateRoots: Array<string> };

export type EncounterPatientLookupFragment = {
  id: string;
  firstName: string;
  lastName: string;
  sex: Sex;
  dateOfBirth: string;
  status: PatientStatus;
};

export type EmployeeLookupFragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  active: boolean;
  providerInfo: { specialty: { id: string; name: string } | null } | null;
};

export type EncounterFragment = {
  id: string;
  providerId: string;
  patientId: string;
  version: string;
  disabled: boolean;
  examination: any | null;
  history: any | null;
  summary: any | null;
  note: any | null;
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    sex: Sex;
    dateOfBirth: string;
    status: PatientStatus;
  };
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
    providerInfo: { specialty: { id: string; name: string } | null } | null;
  };
  appointment: {
    id: string;
    eventId: string;
    type: string;
    title: string | null;
    templateId: string | null;
    careHome: {
      id: string;
      type: CatalogCareHomeType;
      name: string;
      address: {
        street: string;
        city: string;
        region: string | null;
        zipCode: string;
        country: string;
        line2: string | null;
      } | null;
    };
    period: { start: string; end: string };
  } | null;
  glaucomaTests: { portalUrl: string | null } | null;
  glaucomaTestAttempts: Array<{ teleportId: string; resultReceivedAt: string | null }>;
};

export type EncounterOverviewFragment = { id: string; note: any | null };

export type PreviousEncounterFragment = {
  id: string;
  note: any | null;
  examination: any | null;
  history: any | null;
  summary: any | null;
};

export type PastEncounterSummaryFragment = {
  id: string;
  providerId: string;
  patientId: string;
  note: any | null;
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
  };
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    sex: Sex;
    dateOfBirth: string;
    status: PatientStatus;
  };
  appointment: { period: { start: string; end: string } } | null;
};

export type EncounterListItemFragment = {
  id: string;
  providerId: string;
  patientId: string;
  note: any | null;
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    sex: Sex;
    dateOfBirth: string;
    status: PatientStatus;
  };
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
    providerInfo: { specialty: { id: string; name: string } | null } | null;
  };
  appointment: {
    id: string;
    eventId: string;
    type: string;
    title: string | null;
    period: { start: string; end: string };
  } | null;
};

export type EncounterExaminationHistoryItemFragment = {
  id: string;
  examination: any | null;
  appointment: { id: string; period: { start: string; end: string } } | null;
};

export type EncounterSummaryHistoryItemFragment = {
  id: string;
  summary: any | null;
  appointment: { id: string; period: { start: string; end: string } } | null;
};

export type EncounterReportFragment = {
  note: any | null;
  summary: any | null;
  appointment: { period: { start: string } } | null;
  organization: {
    name: string;
    contacts: {
      phone: string;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
    };
  };
  patient: {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
    contacts: { phone: string };
  };
  provider: {
    firstName: string;
    lastName: string;
    providerInfo: { specialty: { name: string } | null } | null;
  };
};

export type UnbilledEncounterListItemFragment = {
  id: string;
  provider: { id: string; firstName: string; lastName: string };
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
    contacts: { phone: string; email: string | null; additionalPhone: string | null };
  };
  appointment: { id: string; period: { start: string; end: string } } | null;
};

export type EncounterReportListItemFragment = {
  id: string;
  version: string;
  summary: any | null;
  note: any | null;
  appointment: { period: { start: string } } | null;
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    careHomeId: string | null;
  };
  provider: { id: string; firstName: string; lastName: string };
};

export type GetEncounterQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEncounterQuery = {
  encounter: {
    id: string;
    providerId: string;
    patientId: string;
    version: string;
    disabled: boolean;
    examination: any | null;
    history: any | null;
    summary: any | null;
    note: any | null;
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      sex: Sex;
      dateOfBirth: string;
      status: PatientStatus;
    };
    provider: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
      providerInfo: { specialty: { id: string; name: string } | null } | null;
    };
    appointment: {
      id: string;
      eventId: string;
      type: string;
      title: string | null;
      templateId: string | null;
      careHome: {
        id: string;
        type: CatalogCareHomeType;
        name: string;
        address: {
          street: string;
          city: string;
          region: string | null;
          zipCode: string;
          country: string;
          line2: string | null;
        } | null;
      };
      period: { start: string; end: string };
    } | null;
    glaucomaTests: { portalUrl: string | null } | null;
    glaucomaTestAttempts: Array<{ teleportId: string; resultReceivedAt: string | null }>;
  } | null;
};

export type GetPreviousEncounterQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPreviousEncounterQuery = {
  encounter: {
    id: string;
    previousEncounter: {
      id: string;
      note: any | null;
      examination: any | null;
      history: any | null;
      summary: any | null;
    } | null;
  } | null;
};

export type GetEncounterByAppointmentEventIdQueryVariables = Exact<{
  appointmentEventId: Scalars['String']['input'];
}>;

export type GetEncounterByAppointmentEventIdQuery = {
  encounterByAppointmentEventId: {
    id: string;
    providerId: string;
    patientId: string;
    version: string;
    disabled: boolean;
    examination: any | null;
    history: any | null;
    summary: any | null;
    note: any | null;
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      sex: Sex;
      dateOfBirth: string;
      status: PatientStatus;
    };
    provider: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
      providerInfo: { specialty: { id: string; name: string } | null } | null;
    };
    appointment: {
      id: string;
      eventId: string;
      type: string;
      title: string | null;
      templateId: string | null;
      careHome: {
        id: string;
        type: CatalogCareHomeType;
        name: string;
        address: {
          street: string;
          city: string;
          region: string | null;
          zipCode: string;
          country: string;
          line2: string | null;
        } | null;
      };
      period: { start: string; end: string };
    } | null;
    glaucomaTests: { portalUrl: string | null } | null;
    glaucomaTestAttempts: Array<{ teleportId: string; resultReceivedAt: string | null }>;
  } | null;
};

export type GetEncounterListQueryVariables = Exact<{
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
  providerIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  patientIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  specialtyIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type GetEncounterListQuery = {
  encounters: Array<{
    id: string;
    providerId: string;
    patientId: string;
    note: any | null;
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      sex: Sex;
      dateOfBirth: string;
      status: PatientStatus;
    };
    provider: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
      providerInfo: { specialty: { id: string; name: string } | null } | null;
    };
    appointment: {
      id: string;
      eventId: string;
      type: string;
      title: string | null;
      period: { start: string; end: string };
    } | null;
  }>;
};

export type GetEncounterReportListQueryVariables = Exact<{
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
  providerIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  patientIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  specialtyIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  careHomeIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type GetEncounterReportListQuery = {
  encounters: Array<{
    id: string;
    version: string;
    summary: any | null;
    note: any | null;
    appointment: { period: { start: string } } | null;
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      dateOfBirth: string;
      careHomeId: string | null;
    };
    provider: { id: string; firstName: string; lastName: string };
  }>;
};

export type GetEncounterCountQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEncounterCountQuery = { encounterCount: number };

export type GetEncounterOverviewQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEncounterOverviewQuery = { encounter: { id: string; note: any | null } | null };

export type GetPastEncounterSummaryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPastEncounterSummaryQuery = {
  encounter: {
    id: string;
    providerId: string;
    patientId: string;
    note: any | null;
    provider: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
    };
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      sex: Sex;
      dateOfBirth: string;
      status: PatientStatus;
    };
    appointment: { period: { start: string; end: string } } | null;
  } | null;
};

export type GetEncounterReportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEncounterReportQuery = {
  encounter: {
    note: any | null;
    summary: any | null;
    appointment: { period: { start: string } } | null;
    organization: {
      name: string;
      contacts: {
        phone: string;
        address: {
          street: string;
          city: string;
          region: string | null;
          country: string;
          zipCode: string;
          line2: string | null;
        };
      };
    };
    patient: {
      firstName: string;
      lastName: string;
      dateOfBirth: string;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
      contacts: { phone: string };
    };
    provider: {
      firstName: string;
      lastName: string;
      providerInfo: { specialty: { name: string } | null } | null;
    };
  } | null;
};

export type GetUnbilledEncounterListQueryVariables = Exact<{
  ids: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;

export type GetUnbilledEncounterListQuery = {
  encounters: Array<{
    id: string;
    provider: { id: string; firstName: string; lastName: string };
    patient: {
      id: string;
      firstName: string;
      lastName: string;
      avatar: string | null;
      contacts: { phone: string; email: string | null; additionalPhone: string | null };
    };
    appointment: { id: string; period: { start: string; end: string } } | null;
  }>;
};

export type GetEncountersExaminationsQueryVariables = Exact<{
  patientIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
}>;

export type GetEncountersExaminationsQuery = {
  encounters: Array<{
    id: string;
    examination: any | null;
    appointment: { id: string; period: { start: string; end: string } } | null;
  }>;
};

export type GetEncountersSummariesQueryVariables = Exact<{
  patientIds: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
}>;

export type GetEncountersSummariesQuery = {
  encounters: Array<{
    id: string;
    summary: any | null;
    appointment: { id: string; period: { start: string; end: string } } | null;
  }>;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ESignatureMetaFragmentDoc = new TypedDocumentString(
  `
    fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
    `,
  { fragmentName: 'ESignatureMeta' },
) as unknown as TypedDocumentString<ESignatureMetaFragment, unknown>;
export const UserLookupFragmentDoc = new TypedDocumentString(
  `
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
    `,
  { fragmentName: 'UserLookup' },
) as unknown as TypedDocumentString<UserLookupFragment, unknown>;
export const ESignatureFragmentDoc = new TypedDocumentString(
  `
    fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}`,
  { fragmentName: 'ESignature' },
) as unknown as TypedDocumentString<ESignatureFragment, unknown>;
export const PatientPortalAppointmentRequestFragmentDoc = new TypedDocumentString(
  `
    fragment PatientPortalAppointmentRequest on AppointmentRequest {
  id
  status
  note
  declinedNote
  createdAt
  requestedPeriod {
    start
    end
  }
  visitorRefs {
    visitorId
    referenceId
    appointmentType {
      id
      name
      durationInMinutes
    }
  }
}
    `,
  { fragmentName: 'PatientPortalAppointmentRequest' },
) as unknown as TypedDocumentString<PatientPortalAppointmentRequestFragment, unknown>;
export const AppointmentTypeTemplateFragmentDoc = new TypedDocumentString(
  `
    fragment AppointmentTypeTemplate on AppointmentTypeTemplate {
  id
  name
  durationInMinutes
  archived
  createdAt
}
    `,
  { fragmentName: 'AppointmentTypeTemplate' },
) as unknown as TypedDocumentString<AppointmentTypeTemplateFragment, unknown>;
export const CatalogCareHomeFragmentDoc = new TypedDocumentString(
  `
    fragment CatalogCareHome on CatalogCareHome {
  id
  name
  type
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
  archived
  providerId
}
    `,
  { fragmentName: 'CatalogCareHome' },
) as unknown as TypedDocumentString<CatalogCareHomeFragment, unknown>;
export const EncounterTemplateFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterTemplate on EncounterTemplate {
  id
  root
  directory
  name
  note
}
    `,
  { fragmentName: 'EncounterTemplate' },
) as unknown as TypedDocumentString<EncounterTemplateFragment, unknown>;
export const EncounterPatientLookupFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
    `,
  { fragmentName: 'EncounterPatientLookup' },
) as unknown as TypedDocumentString<EncounterPatientLookupFragment, unknown>;
export const EmployeeLookupFragmentDoc = new TypedDocumentString(
  `
    fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}`,
  { fragmentName: 'EmployeeLookup' },
) as unknown as TypedDocumentString<EmployeeLookupFragment, unknown>;
export const CatalogCareHomeLookupFragmentDoc = new TypedDocumentString(
  `
    fragment CatalogCareHomeLookup on CatalogCareHome {
  id
  type
  name
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
}
    `,
  { fragmentName: 'CatalogCareHomeLookup' },
) as unknown as TypedDocumentString<CatalogCareHomeLookupFragment, unknown>;
export const EncounterFragmentDoc = new TypedDocumentString(
  `
    fragment Encounter on Encounter {
  id
  providerId
  patientId
  version
  disabled
  patient {
    ...EncounterPatientLookup
  }
  provider {
    ...EmployeeLookup
  }
  appointment {
    id
    eventId
    type
    title
    templateId
    careHome {
      ...CatalogCareHomeLookup
    }
    period {
      start
      end
    }
  }
  examination
  glaucomaTests {
    portalUrl
  }
  glaucomaTestAttempts {
    teleportId
    resultReceivedAt
  }
  history
  summary
  note
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment CatalogCareHomeLookup on CatalogCareHome {
  id
  type
  name
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}`,
  { fragmentName: 'Encounter' },
) as unknown as TypedDocumentString<EncounterFragment, unknown>;
export const EncounterOverviewFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterOverview on Encounter {
  id
  note
}
    `,
  { fragmentName: 'EncounterOverview' },
) as unknown as TypedDocumentString<EncounterOverviewFragment, unknown>;
export const PreviousEncounterFragmentDoc = new TypedDocumentString(
  `
    fragment PreviousEncounter on Encounter {
  id
  note
  examination
  history
  summary
}
    `,
  { fragmentName: 'PreviousEncounter' },
) as unknown as TypedDocumentString<PreviousEncounterFragment, unknown>;
export const PastEncounterSummaryFragmentDoc = new TypedDocumentString(
  `
    fragment PastEncounterSummary on Encounter {
  id
  providerId
  provider {
    ...UserLookup
  }
  patientId
  patient {
    ...EncounterPatientLookup
  }
  appointment {
    period {
      start
      end
    }
  }
  note
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}`,
  { fragmentName: 'PastEncounterSummary' },
) as unknown as TypedDocumentString<PastEncounterSummaryFragment, unknown>;
export const EncounterListItemFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterListItem on Encounter {
  id
  providerId
  patientId
  patient {
    ...EncounterPatientLookup
  }
  provider {
    ...EmployeeLookup
  }
  appointment {
    id
    eventId
    type
    title
    period {
      start
      end
    }
  }
  note
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}`,
  { fragmentName: 'EncounterListItem' },
) as unknown as TypedDocumentString<EncounterListItemFragment, unknown>;
export const EncounterExaminationHistoryItemFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterExaminationHistoryItem on Encounter {
  id
  appointment {
    id
    period {
      start
      end
    }
  }
  examination
}
    `,
  { fragmentName: 'EncounterExaminationHistoryItem' },
) as unknown as TypedDocumentString<EncounterExaminationHistoryItemFragment, unknown>;
export const EncounterSummaryHistoryItemFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterSummaryHistoryItem on Encounter {
  id
  appointment {
    id
    period {
      start
      end
    }
  }
  summary
}
    `,
  { fragmentName: 'EncounterSummaryHistoryItem' },
) as unknown as TypedDocumentString<EncounterSummaryHistoryItemFragment, unknown>;
export const AddressFragmentDoc = new TypedDocumentString(
  `
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
    `,
  { fragmentName: 'Address' },
) as unknown as TypedDocumentString<AddressFragment, unknown>;
export const EncounterReportFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterReport on Encounter {
  appointment {
    period {
      start
    }
  }
  note
  summary
  organization {
    contacts {
      address {
        ...Address
      }
      phone
    }
    name
  }
  patient {
    firstName
    lastName
    address {
      ...Address
    }
    dateOfBirth
    contacts {
      phone
    }
  }
  provider {
    firstName
    lastName
    providerInfo {
      specialty {
        name
      }
    }
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}`,
  { fragmentName: 'EncounterReport' },
) as unknown as TypedDocumentString<EncounterReportFragment, unknown>;
export const UnbilledEncounterListItemFragmentDoc = new TypedDocumentString(
  `
    fragment UnbilledEncounterListItem on Encounter {
  id
  provider {
    id
    firstName
    lastName
  }
  patient {
    id
    firstName
    lastName
    avatar
    contacts {
      phone
      email
      additionalPhone
    }
  }
  appointment {
    id
    period {
      start
      end
    }
  }
}
    `,
  { fragmentName: 'UnbilledEncounterListItem' },
) as unknown as TypedDocumentString<UnbilledEncounterListItemFragment, unknown>;
export const EncounterReportListItemFragmentDoc = new TypedDocumentString(
  `
    fragment EncounterReportListItem on Encounter {
  id
  version
  appointment {
    period {
      start
    }
  }
  patient {
    id
    firstName
    lastName
    dateOfBirth
    careHomeId
  }
  provider {
    id
    firstName
    lastName
  }
  summary
  note
}
    `,
  { fragmentName: 'EncounterReportListItem' },
) as unknown as TypedDocumentString<EncounterReportListItemFragment, unknown>;
export const GetPatientPortalAppointmentRequestsDocument = new TypedDocumentString(`
    query getPatientPortalAppointmentRequests($query: JSON) {
  appointmentRequests(query: $query) {
    ...PatientPortalAppointmentRequest
  }
}
    fragment PatientPortalAppointmentRequest on AppointmentRequest {
  id
  status
  note
  declinedNote
  createdAt
  requestedPeriod {
    start
    end
  }
  visitorRefs {
    visitorId
    referenceId
    appointmentType {
      id
      name
      durationInMinutes
    }
  }
}`) as unknown as TypedDocumentString<
  GetPatientPortalAppointmentRequestsQuery,
  GetPatientPortalAppointmentRequestsQueryVariables
>;
export const GetPatientPortalAppointmentRequestDocument = new TypedDocumentString(`
    query getPatientPortalAppointmentRequest($id: String!) {
  appointmentRequest(id: $id) {
    ...PatientPortalAppointmentRequest
  }
}
    fragment PatientPortalAppointmentRequest on AppointmentRequest {
  id
  status
  note
  declinedNote
  createdAt
  requestedPeriod {
    start
    end
  }
  visitorRefs {
    visitorId
    referenceId
    appointmentType {
      id
      name
      durationInMinutes
    }
  }
}`) as unknown as TypedDocumentString<
  GetPatientPortalAppointmentRequestQuery,
  GetPatientPortalAppointmentRequestQueryVariables
>;
export const GetAppointmentTypeTemplatesDocument = new TypedDocumentString(`
    query getAppointmentTypeTemplates($filter: String) {
  appointmentTypeTemplates(filter: $filter) {
    ...AppointmentTypeTemplate
  }
}
    fragment AppointmentTypeTemplate on AppointmentTypeTemplate {
  id
  name
  durationInMinutes
  archived
  createdAt
}`) as unknown as TypedDocumentString<
  GetAppointmentTypeTemplatesQuery,
  GetAppointmentTypeTemplatesQueryVariables
>;
export const GetAppointmentTypeTemplateDocument = new TypedDocumentString(`
    query getAppointmentTypeTemplate($id: UUID!) {
  appointmentTypeTemplate(id: $id) {
    ...AppointmentTypeTemplate
  }
}
    fragment AppointmentTypeTemplate on AppointmentTypeTemplate {
  id
  name
  durationInMinutes
  archived
  createdAt
}`) as unknown as TypedDocumentString<
  GetAppointmentTypeTemplateQuery,
  GetAppointmentTypeTemplateQueryVariables
>;
export const GetCatalogCareHomesListSegmentDocument = new TypedDocumentString(`
    query getCatalogCareHomesListSegment($query: JSON) {
  careHomesListSegment(query: $query) {
    items {
      ...CatalogCareHome
    }
    total
  }
}
    fragment CatalogCareHome on CatalogCareHome {
  id
  name
  type
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
  archived
  providerId
}`) as unknown as TypedDocumentString<
  GetCatalogCareHomesListSegmentQuery,
  GetCatalogCareHomesListSegmentQueryVariables
>;
export const GetCatalogCareHomesDocument = new TypedDocumentString(`
    query getCatalogCareHomes($query: String) {
  catalogCareHomes(query: $query) {
    ...CatalogCareHome
  }
}
    fragment CatalogCareHome on CatalogCareHome {
  id
  name
  type
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
  archived
  providerId
}`) as unknown as TypedDocumentString<GetCatalogCareHomesQuery, GetCatalogCareHomesQueryVariables>;
export const GetCatalogCareHomesLookupListDocument = new TypedDocumentString(`
    query getCatalogCareHomesLookupList($query: String) {
  catalogCareHomes(query: $query) {
    ...CatalogCareHomeLookup
  }
}
    fragment CatalogCareHomeLookup on CatalogCareHome {
  id
  type
  name
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
}`) as unknown as TypedDocumentString<
  GetCatalogCareHomesLookupListQuery,
  GetCatalogCareHomesLookupListQueryVariables
>;
export const GetEncounterTemplatesDocument = new TypedDocumentString(`
    query getEncounterTemplates($filter: String) {
  encounterTemplates(filter: $filter) {
    ...EncounterTemplate
  }
}
    fragment EncounterTemplate on EncounterTemplate {
  id
  root
  directory
  name
  note
}`) as unknown as TypedDocumentString<GetEncounterTemplatesQuery, GetEncounterTemplatesQueryVariables>;
export const GetEncounterTemplateDocument = new TypedDocumentString(`
    query getEncounterTemplate($id: UUID!) {
  encounterTemplate(id: $id) {
    ...EncounterTemplate
  }
}
    fragment EncounterTemplate on EncounterTemplate {
  id
  root
  directory
  name
  note
}`) as unknown as TypedDocumentString<GetEncounterTemplateQuery, GetEncounterTemplateQueryVariables>;
export const GetEncounterTemplateRootsDocument = new TypedDocumentString(`
    query getEncounterTemplateRoots($filter: String) {
  encounterTemplateRoots(filter: $filter)
}
    `) as unknown as TypedDocumentString<
  GetEncounterTemplateRootsQuery,
  GetEncounterTemplateRootsQueryVariables
>;
export const GetEncounterDocument = new TypedDocumentString(`
    query getEncounter($id: UUID!) {
  encounter(id: $id) {
    ...Encounter
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment CatalogCareHomeLookup on CatalogCareHome {
  id
  type
  name
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}
fragment Encounter on Encounter {
  id
  providerId
  patientId
  version
  disabled
  patient {
    ...EncounterPatientLookup
  }
  provider {
    ...EmployeeLookup
  }
  appointment {
    id
    eventId
    type
    title
    templateId
    careHome {
      ...CatalogCareHomeLookup
    }
    period {
      start
      end
    }
  }
  examination
  glaucomaTests {
    portalUrl
  }
  glaucomaTestAttempts {
    teleportId
    resultReceivedAt
  }
  history
  summary
  note
}`) as unknown as TypedDocumentString<GetEncounterQuery, GetEncounterQueryVariables>;
export const GetPreviousEncounterDocument = new TypedDocumentString(`
    query getPreviousEncounter($id: UUID!) {
  encounter(id: $id) {
    id
    previousEncounter {
      ...PreviousEncounter
    }
  }
}
    fragment PreviousEncounter on Encounter {
  id
  note
  examination
  history
  summary
}`) as unknown as TypedDocumentString<GetPreviousEncounterQuery, GetPreviousEncounterQueryVariables>;
export const GetEncounterByAppointmentEventIdDocument = new TypedDocumentString(`
    query getEncounterByAppointmentEventId($appointmentEventId: String!) {
  encounterByAppointmentEventId(appointmentEventId: $appointmentEventId) {
    ...Encounter
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment CatalogCareHomeLookup on CatalogCareHome {
  id
  type
  name
  address {
    street
    city
    region
    zipCode
    country
    line2
  }
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}
fragment Encounter on Encounter {
  id
  providerId
  patientId
  version
  disabled
  patient {
    ...EncounterPatientLookup
  }
  provider {
    ...EmployeeLookup
  }
  appointment {
    id
    eventId
    type
    title
    templateId
    careHome {
      ...CatalogCareHomeLookup
    }
    period {
      start
      end
    }
  }
  examination
  glaucomaTests {
    portalUrl
  }
  glaucomaTestAttempts {
    teleportId
    resultReceivedAt
  }
  history
  summary
  note
}`) as unknown as TypedDocumentString<
  GetEncounterByAppointmentEventIdQuery,
  GetEncounterByAppointmentEventIdQueryVariables
>;
export const GetEncounterListDocument = new TypedDocumentString(`
    query getEncounterList($period: PeriodOfDateTimeOffsetInput, $providerIds: [UUID!], $patientIds: [UUID!], $specialtyIds: [UUID!]) {
  encounters(
    period: $period
    providerIds: $providerIds
    patientIds: $patientIds
    specialtyIds: $specialtyIds
  ) {
    ...EncounterListItem
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment EmployeeLookup on Employee {
  ...UserLookup
  providerInfo {
    specialty {
      id
      name
    }
  }
}
fragment EncounterListItem on Encounter {
  id
  providerId
  patientId
  patient {
    ...EncounterPatientLookup
  }
  provider {
    ...EmployeeLookup
  }
  appointment {
    id
    eventId
    type
    title
    period {
      start
      end
    }
  }
  note
}`) as unknown as TypedDocumentString<GetEncounterListQuery, GetEncounterListQueryVariables>;
export const GetEncounterReportListDocument = new TypedDocumentString(`
    query getEncounterReportList($period: PeriodOfDateTimeOffsetInput, $providerIds: [UUID!], $patientIds: [UUID!], $specialtyIds: [UUID!], $careHomeIds: [UUID!]) {
  encounters(
    period: $period
    providerIds: $providerIds
    patientIds: $patientIds
    specialtyIds: $specialtyIds
    careHomeIds: $careHomeIds
  ) {
    ...EncounterReportListItem
  }
}
    fragment EncounterReportListItem on Encounter {
  id
  version
  appointment {
    period {
      start
    }
  }
  patient {
    id
    firstName
    lastName
    dateOfBirth
    careHomeId
  }
  provider {
    id
    firstName
    lastName
  }
  summary
  note
}`) as unknown as TypedDocumentString<GetEncounterReportListQuery, GetEncounterReportListQueryVariables>;
export const GetEncounterCountDocument = new TypedDocumentString(`
    query getEncounterCount($filter: String) {
  encounterCount(filter: $filter)
}
    `) as unknown as TypedDocumentString<GetEncounterCountQuery, GetEncounterCountQueryVariables>;
export const GetEncounterOverviewDocument = new TypedDocumentString(`
    query getEncounterOverview($id: UUID!) {
  encounter(id: $id) {
    ...EncounterOverview
  }
}
    fragment EncounterOverview on Encounter {
  id
  note
}`) as unknown as TypedDocumentString<GetEncounterOverviewQuery, GetEncounterOverviewQueryVariables>;
export const GetPastEncounterSummaryDocument = new TypedDocumentString(`
    query getPastEncounterSummary($id: UUID!) {
  encounter(id: $id) {
    ...PastEncounterSummary
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment EncounterPatientLookup on Patient {
  id
  firstName
  lastName
  sex
  dateOfBirth
  status
}
fragment PastEncounterSummary on Encounter {
  id
  providerId
  provider {
    ...UserLookup
  }
  patientId
  patient {
    ...EncounterPatientLookup
  }
  appointment {
    period {
      start
      end
    }
  }
  note
}`) as unknown as TypedDocumentString<GetPastEncounterSummaryQuery, GetPastEncounterSummaryQueryVariables>;
export const GetEncounterReportDocument = new TypedDocumentString(`
    query getEncounterReport($id: UUID!) {
  encounter(id: $id) {
    ...EncounterReport
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment EncounterReport on Encounter {
  appointment {
    period {
      start
    }
  }
  note
  summary
  organization {
    contacts {
      address {
        ...Address
      }
      phone
    }
    name
  }
  patient {
    firstName
    lastName
    address {
      ...Address
    }
    dateOfBirth
    contacts {
      phone
    }
  }
  provider {
    firstName
    lastName
    providerInfo {
      specialty {
        name
      }
    }
  }
}`) as unknown as TypedDocumentString<GetEncounterReportQuery, GetEncounterReportQueryVariables>;
export const GetUnbilledEncounterListDocument = new TypedDocumentString(`
    query getUnbilledEncounterList($ids: [UUID!]) {
  encounters(hasClaim: false, ids: $ids) {
    ...UnbilledEncounterListItem
  }
}
    fragment UnbilledEncounterListItem on Encounter {
  id
  provider {
    id
    firstName
    lastName
  }
  patient {
    id
    firstName
    lastName
    avatar
    contacts {
      phone
      email
      additionalPhone
    }
  }
  appointment {
    id
    period {
      start
      end
    }
  }
}`) as unknown as TypedDocumentString<GetUnbilledEncounterListQuery, GetUnbilledEncounterListQueryVariables>;
export const GetEncountersExaminationsDocument = new TypedDocumentString(`
    query getEncountersExaminations($patientIds: [UUID!], $period: PeriodOfDateTimeOffsetInput) {
  encounters(patientIds: $patientIds, period: $period) {
    ...EncounterExaminationHistoryItem
  }
}
    fragment EncounterExaminationHistoryItem on Encounter {
  id
  appointment {
    id
    period {
      start
      end
    }
  }
  examination
}`) as unknown as TypedDocumentString<
  GetEncountersExaminationsQuery,
  GetEncountersExaminationsQueryVariables
>;
export const GetEncountersSummariesDocument = new TypedDocumentString(`
    query getEncountersSummaries($patientIds: [UUID!], $period: PeriodOfDateTimeOffsetInput) {
  encounters(patientIds: $patientIds, period: $period) {
    ...EncounterSummaryHistoryItem
  }
}
    fragment EncounterSummaryHistoryItem on Encounter {
  id
  appointment {
    id
    period {
      start
      end
    }
  }
  summary
}`) as unknown as TypedDocumentString<GetEncountersSummariesQuery, GetEncountersSummariesQueryVariables>;
